import { FormattedMessage, IntlProvider } from "react-intl";
import jobMessages from "../translate/jobMessages";
import { useContext } from "react";
import { LangContext } from "../App";
import Offer from "../images/offer.png";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Job = () => {
  const language = useContext(LangContext);

  const iab_pl = [
    "Gromadzisz dane w teczkach lub arkuszach kalkulacyjnych, a wyszukiwanie danych jest uciążliwe?",
    "Posiadasz bazę dokumentów, które wymagają obiegu w firmie?",
    "Potrzebujesz koordynacji działań oraz uprawnień między Zespołami w istniejącym systemie, którego nie da się łatwo zmienić?",
    "Potrzebujesz wsparcia w rozwoju i utrzymaniu środowiska? Skontaktuj się ze mną.",
  ];

  const iab_en = [
    "Gathers data in folders or spreadsheets, making data search cumbersome",
    "Has a database of documents that require circulation within the company",
    "Needs coordination of actions and permissions between teams in an existing system that is difficult to change",
    "Needs support in the development and maintenance of the environment – contact me.",
  ];

  const erp_pl = [
    "Zrozumienie procesów biznesowych i integrację ze starymi systemami.",
    "Konfiguracja systemu ERP zgodnie z niestandardowymi potrzebami organizacji.",
    "Określanie parametrów systemowych oraz uprawnień i ról użytkowników.",
    "Szkolenie, wsparcie techniczne oraz przygotowanie materiałów instruktażowych.",
    "Prowadzenie testów integracyjnych, jakościowych i zarządzanie zmianą.",
    "Koordynacja zespołu projektowego oraz tworzenie wskaźników wydajności (KPI).",
  ];

  const erp_en = [
    "understanding business processes and integrating with legacy systems,",
    "configuring ERP systems to meet the organization's specific requirements,",
    "defining system parameters, user permissions, and roles,",
    "providing training, technical support, and preparing user documentation,",
    "conducting integration and quality testing, and managing change,",
    "coordinating project teams and developing Key Performance Indicators (KPIs).",
  ];

  const si_pl = [
    "Strony internetowe są realizowane zgodnie z indywidualnie ustalonym projektem graficznym.",
    "Zapewniam nowoczesny, responsywny wygląd i wysoką jakość wykonania.",
    "Oferuję możliwość samodzielnej edycji treści przez zamawiającego (CMS).",
    "Gwarantuję łatwą obsługę i kompleksowe wsparcie techniczne po wdrożeniu.",
  ];

  const si_en = [
    "Websites are developed according to individually agreed graphic designs.",
    "I provide a modern, responsive look and high-quality execution.",
    "I offer the possibility of independent content editing by the client (CMS).",
    "I guarantee easy operation and comprehensive technical support after deployment.",
  ];
  const sd_pl = [
    "Poprzez wnikliwą analizę istniejącego kodu potrafię zrealizować zmiany w oprogramowaniu, którego nikt nie wspiera, a istnieje konieczność dokonania zmian, które są istotne dla Firmy.",
    "Mam duże doświadczenie w kilku językach oprogramowania, które powszechnie mogą już być nieużywane i ich znajomość może okazać się przydatna w takich przypadkach.",
  ];
  const sd_en = [
    "Through careful analysis of existing code, I can implement changes in software that no one else supports, where there is a need for modifications that are critical for the company.",
    "I have extensive experience in several software languages ​​that may no longer be widely used and I will be happy to help you with this.",
  ];
  const zs_pl = [
    "Poprzez wnikliwą analizę istniejącego kodu potrafię zrealizować zmiany w oprogramowaniu, którego nikt nie wspiera, a istnieje konieczność dokonania zmian, które są istotne dla Firmy.",
    "Mam również umiejętności organizacyjne i planistyczne, umożliwiające skuteczne zarządzanie projektami IT.",
    "Posiadam również bardzo dobrą zdolność komunikacji i negocjacji, która potrafi budować pozytywne relacje z klientami i współpracownikami.",
    "Realizuję założenia budżetu IT ściśle w porozumieniu z Zarządem Firmy.",
    "Koncentruję się na wynikach i umiejętnościach podejmowania decyzji w warunkach zmienności i presji czasu.",
    "Jeśli szukasz doświadczonego lidera zespołu IT, który zapewni skuteczne zarządzanie i wysoką jakość usług informatycznych, skontaktuj się ze mną. Jestem gotów podjąć wyzwanie i wspólnie osiągnąć sukces!",
  ];
  const zs_en = [
    "I have the ability to motivate teams to achieve shared goals.",
    "In my mind I also have organizational and planning skills, enabling effective management of IT projects.",
    "Personally I also have very good communication and negotiation skills, enabling building positive relationships with clients and colleagues.",
    "I implement the IT budget assumptions in strict consultation with the Company's Management Board.",
    "I focus on results and decision-making skills under conditions of variability and time pressure.",
    "If you are looking for an experienced IT team leader who will ensure effective management and high quality of IT services, contact me.I am ready to take up the challenge and achieve success together!",
  ];
  const wit_pl = [
    "rozwiązywanie problemów: szybka diagnoza sprzętu IT i minimalizowanie przestojów",
    "wsparcie użytkowników: pomoc zdalna, telefoniczna i osobista w instalacji aplikacji i konfiguracji sprzętu",
    "utrzymanie systemów: ciągłe monitorowanie wydajności infrastruktury IT, backupy i aktualizacje",
    "dokumentacja: tworzenie raportów serwisowych oraz bazy wiedzy dla użytkowników.",
  ];
  const wit_en = [
    "Problem-solving: quick diagnosis of IT hardware and minimizing downtime.",
    "User support: remote, phone, and in-person assistance with application installation and hardware configuration.",
    "System maintenance: continuous monitoring of IT infrastructure performance, backups, and updates.",
    "Documentation: creating service reports and a knowledge base for users.",
  ];

  const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };
  const styles = {
    card: {
      background: "#ffffff",
      borderRadius: "4px",
      padding: "36px",
      boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
      border: "1px solid #e2e8f0",
      height: "100%",
      boxSizing: "border-box",
    },
    cardHeaderGradient: {
      background: "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
      padding: "10px",
      borderRadius: "22px",
      textAlign: "left",
      marginBottom: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    cardTitleGradient: {
      color: "#fff",
      fontSize: "20px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "20px",
      paddingLeft: "10px",
    },
  };
  const cardContentStyle = {
    p: 4,
    pt: 0,
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "1340px",
    maxWidth: "100%",
  };
  const cardStyle = {
    height: "100%",
    borderRadius: "24px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
    border: "1px solid #e2e8f0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  };
  const listStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    m: 0,
    p: 0,
    listStyle: "none",
  };
  const renderList = (skills) => (
    <Box component="ul" sx={listStyle}>
      {skills.map((skill, index) => (
        <Box
          component="li"
          key={`${index}-${skill}`}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
            color: "#475569",
            fontSize: "15px",
            lineHeight: 1.6,
          }}
        >
          <CheckCircleOutlineIcon
            sx={{
              color: "#274C77",
              fontSize: 19,
              flexShrink: 0,
              mt: "2px",
            }}
          />
          <Box component="span">{skill}</Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "OfferCatalog",
            name: "Oferta usług Fullstack Developera",
            url: "https://michaljaskulski.pl/oferta",
            itemListElement: [
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Aplikacje webowe w React",
                  description:
                    "Projektowanie i tworzenie nowoczesnych aplikacji SPA w React, Vite i Next.js.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Backend API (Node.js / PHP)",
                  description:
                    "Tworzenie skalowalnych backendów, REST API oraz integracji z bazami danych.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Systemy biznesowe dla firm",
                  description:
                    "Dedykowane systemy usprawniające procesy biznesowe i raportowanie.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Bazy danych MySQL i MSSQL",
                  description:
                    "Projektowanie struktur, optymalizacja zapytań, migracje i backupy.",
                },
              },
              {
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: "Konfiguracja i utrzymanie serwerów VPS",
                  description:
                    "Linux, Docker, SSL, monitoring i utrzymanie środowisk produkcyjnych.",
                },
              },
            ],
          })}
        </script>
        <title>Internetowe aplikacje bazodanowe | Strony internetowe</title>
        <meta
          name="description"
          content="Nowoczesne i bezpieczne responsywne aplikacje bazodanowe"
        />
      </Helmet>

      <Box className="page-container">
        <IntlProvider locale={language} messages={jobMessages[language]}>
          <AnimatePresence>
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={textVariants}
            >
              <Container maxWidth="lg">
                <Box sx={{ textAlign: "center", mb: 6 }}>
                  <h1>
                    <FormattedMessage id="offer" />
                  </h1>
                </Box>
                <Grid container spacing={4} alignItems="stretch">
                  <Grid item xs={12} md={6} sx={{ display: "flex" }}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                          maxWidth: "130%",
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="webapp" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? iab_pl : iab_en)}
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="implementation" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? erp_pl : erp_en)}
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* KARTA 3: website */}
                  <Grid item xs={12} md={6}>
                    <Card
                      sx={{
                        height: "100%",
                        borderRadius: "24px",
                        boxShadow: "0 10px 30px -10px rgba(0,0,0,0.04)",
                        border: "1px solid #e2e8f0",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="website" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? si_pl : si_en)}
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 4: development */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="development" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? sd_pl : sd_en)}
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 5: managerit */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="managerit" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? zs_pl : zs_en)}
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* KARTA 6: supportit */}
                  <Grid item xs={12} md={6}>
                    <Card sx={cardStyle}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(135deg, #1E3A5F 0%, #274C77 100%)",
                          p: 2,
                          borderRadius: "20px 20px 0 0",
                          mb: 3,
                        }}
                      >
                        <h2 style={styles.cardTitleGradient}>
                          <FormattedMessage id="supportit" />
                        </h2>
                      </Box>
                      <CardContent sx={cardContentStyle}>
                        {renderList(language === "pl" ? wit_pl : wit_en)}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

                {/* Call to Action & Image Section */}
                <Box sx={{ textAlign: "center", mt: 8 }}>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: "#0f172a", mb: 2 }}
                  >
                    {language === "pl"
                      ? "Jesteś zainteresowany?"
                      : "Are you interested?"}
                    <br />
                    <a
                      href="/kontakt"
                      style={{
                        color: "#4f46e5",
                        textDecoration: "underline",
                        fontWeight: 600,
                      }}
                    >
                      {language === "pl"
                        ? "skontaktuj się ze mną"
                        : "contact me"}
                    </a>
                  </Typography>

                  {Offer && (
                    <Box sx={{ mt: 4 }}>
                      <Box
                        component="img"
                        src={Offer}
                        alt="Offer landscape screen"
                        sx={{
                          maxWidth: "100%",
                          width: "400px",
                          height: "auto",
                          borderRadius: "20px",
                          boxShadow: "0 20px 40px -20px rgba(0,0,0,0.1)",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Container>
            </motion.div>
          </AnimatePresence>
        </IntlProvider>
      </Box>
    </>
  );
};

export default Job;
